var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewTestBtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "review_test_btn",
    "data-name": "review test btn",
    transform: "translate(1.349 -5.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.008 8.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0V13.253H9.519V0ZM7.942,11.676H1.578V1.578H7.942Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group",
    transform: "translate(14.788 8.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H9.519V1.578H0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    "data-name": "Group",
    transform: "translate(14.788 11.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H6.364V1.578H0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    "data-name": "Group",
    transform: "translate(14.788 15.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H9.519V1.578H0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    "data-name": "Group",
    transform: "translate(14.788 19.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H6.364V1.578H0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    transform: "translate(-1.349 5.227)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 19,
    rx: 3.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewTestBtn);
export default __webpack_public_path__ + "static/media/review-test-btn.be8528a0b4808085bd280a7f7b75f773.svg";
export { ForwardRef as ReactComponent };